// Change label on search for EN site
(function($) {    
    // Change text on search button in EN site
    if($('#en').length ){
        $('#en .header-section #site-header .left-header .siteMenu .menu li.search a').text('Search');
    }
})(jQuery);